import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from '../account/shared/user.service';
import { environment } from '../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { FunctionalityUpdate } from './functionality-update.interface';

@Injectable({ providedIn: 'root' })
export class AppUpdatesService {

    hubUrl: string = environment.hubURL;
    atCloudAppId : number = 1;


    private lastUpdateSource = new Subject<Date | null>();
    updateCount$ = this.lastUpdateSource.asObservable();

    private readonly _http = inject(HttpClient);
    private readonly _UserService = inject(UserService);

    getUpdates(): Observable<FunctionalityUpdate[]> {
        return this._http.get<FunctionalityUpdate[]>(this.hubUrl + 'api/appfunctionality?appId=' + this.atCloudAppId, {
            headers: this.getHeaders()
        });
    }

    addUpdate(title: string, description: string): Observable<boolean> {
        let username = sessionStorage.getItem('userName');
        return this._http.put<boolean>(this.hubUrl + 'api/appfunctionality', {appId: 1, title: title, description: description, author:username }, {
            headers: this.getHeaders()
        });
    }

    deleteUpdate(id: number): Observable<boolean> {
        return this._http.delete<boolean>(this.hubUrl + 'api/appfunctionality/' + id, {
            headers: this.getHeaders()
        });
    }

    updateLastUpdateDate() {
        this._http.get<FunctionalityUpdate[]>(this.hubUrl + 'api/appfunctionality?appId=' + this.atCloudAppId, {
            headers: this.getHeaders()
        }).subscribe(n => {
            if (n.length === 0) {
                this.lastUpdateSource.next(null);
            }
            else {
                this.lastUpdateSource.next(n[0].postedAt);
            }
        });
    }

    private getHeaders(): HttpHeaders {

        let headers = new HttpHeaders();

        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('x-api-key', environment.hubAPIKey);
        headers = headers.set('Authorization', 'Bearer ' + this._UserService.getAccessToken());
        return headers;
    }


}

export interface ErrorTypesReport {
    errorMessage: string;
    count: number;
}
